import { render } from "./Steps.vue?vue&type=template&id=d31c52d0"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/InfoNugget/Steps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d31c52d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d31c52d0', __exports__)) {
    api.reload('d31c52d0', __exports__)
  }
  
  module.hot.accept("./Steps.vue?vue&type=template&id=d31c52d0", () => {
    api.rerender('d31c52d0', render)
  })

}


export default __exports__